module.exports = __webpack_public_path__ + "static/oatmeal-1f88606064c0f9ea2584f69dc1c03196.jpg";